






















































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ZuzhijiagouList,
  UsersList,
  ResetPwd,
  BanApplyAccount,
  CheckInviteCode,
} from "@/request/yonghuquanxian";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    Pagination,
    MainHeader,
    NavLeft,
  },
})
export default class ZhglList extends Vue {
  private window: any = window;
  private filter: any = {
    search: "",
    institution_id: "",
    current_page: 1,
    page_count: 10,
    sort_value: "0",
  };
  private totalCount: any = 0;
  private totalPage: any = 0;
  private jigous: any[] = [];
  private users: any[] = [];
  private ifShowSelectJigou: boolean = false;
  private user: any = {};
  private ifShowInviteCode: boolean = false;
  private inviteCodes: any[] = [];
  private get localFilter() {
    if (!localStorage.getItem("zhglFilter")) {
      return {};
    } else {
      return JSON.parse(localStorage.getItem("zhglFilter") || "");
    }
  }
  private set localFilter(val) {
    if (!val) {
      return;
    }
    localStorage.setItem("zhglFilter", JSON.stringify(val));
  }
  /**
   * @description 跳转添加用户
   */
  private jumpAddUser() {
    this.$router.push({
      path: "/main/yhqx/zhgl-compose",
    });
  }
  /**
   * @description 获取组织架构列表
   */
  private fetchJigouList() {
    // const params: any = {
    //   params: {
    //     search: this.filter.search,
    //   },
    // };
    const params: any = {};
    ZuzhijiagouList(this, params).then((data: any) => {
      data.forEach((first: any) => {
        if (first["sub_institutions"]) {
          first["open"] = true;
          first["sub_institutions"].forEach((second: any) => {
            if (second["sub_institutions"]) {
              second["open"] = true;
            } else {
              second["open"] = false;
            }
          });
        } else {
          first["open"] = false;
        }
      });
      this.jigous = data;
    });
  }
  /**
   * @description 获取用户列表
   */
  private fetchUsers() {
    const params: any = this.filter;
    UsersList(this, params).then((data: any) => {
      this.localFilter = this.filter;
      this.users = data.users;
      this.totalCount = data.total_count;
      this.totalPage = data.total_page;
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filter.current_page = 1;
    this.fetchUsers();
    // this.fetchJigouList();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filter.sort_value = ev["order"] === "ascending" ? "1" : "0";
    this.search();
  }
  /**
   * @description 按照机构来查找
   */
  private searchInstitution(id) {
    this.filter["institution_id"] = id;
    this.search();
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val) {
    this.filter.current_page = val;
    this.fetchUsers();
  }
  /**
   * @description 自动计算角色
   */
  private calJuese(juese) {
    let jigouText = "";
    juese["组织机构"].forEach((jigou: any) => {
      jigouText += jigou["名称"] + "-";
    });
    jigouText = jigouText.substring(0, jigouText.length - 1);
    return juese["role"]["名称"] + "(" + jigouText + ")";
  }
  /**
   * @description 跳转用户编辑
   */
  private jumpCompose(user) {
    if (user["状态"] === "禁用") {
      this.$message.warning("该账户已经禁用，不能编辑");
      return;
    }
    console.log(user);
    if (user["角色"].length === 1) {
      const roleId = user["角色"][0]["role"]["role_id"];
      const zuzhiLength = user["角色"][0]["组织机构"].length;
      const insId =
        user["角色"][0]["组织机构"][zuzhiLength - 1]["institution_id"];
      this.$router.push({
        path: "/main/yhqx/zhgl-compose",
        query: {
          id: user["user_id"],
          role_id: roleId,
          insId,
        },
      });
    } else {
      this.openSelectJigouDialog(user);
    }
  }
  /**
   * @description 打开选择机构弹窗
   */
  private openSelectJigouDialog(user) {
    this.user = user;
    this.ifShowSelectJigou = true;
  }
  /**
   * @description 选定某个角色
   */
  private selectJigou(juese) {
    const roleId = juese["role"]["role_id"];
    const zuzhiLength = juese["组织机构"].length;
    const insId = juese["组织机构"][zuzhiLength - 1]["institution_id"];
    this.$router.push({
      path: "/main/yhqx/zhgl-compose",
      query: {
        id: this.user["user_id"],
        role_id: roleId,
        insId,
      },
    });
  }
  /**
   * @description 重置用户密码
   */
  private resetPwd(user) {
    this.$confirm("确定要重置该账号的密码吗？")
      .then(() => {
        const params: any = {
          user_id: user.user_id,
        };
        ResetPwd(this, params).then((data: any) => {
          this.$message.success("重置成功");
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  /**
   * @description 禁用或启用账号
   */
  private banApplyAccount(user) {
    const action: any = user["状态"] === "禁用" ? "启用" : "禁用";
    if (action === "禁用") {
      this.$confirm("禁用后该账户不能进入该网站，确定要禁用吗？")
        .then(() => {
          const params: any = {
            user_id: user.user_id,
            action,
          };
          BanApplyAccount(this, params).then((data: any) => {
            this.$message.success(action + "成功");
            this.fetchUsers();
          });
        })
        .catch((e) => {
          console.log("取消了");
        });
    } else {
      const params: any = {
        user_id: user.user_id,
        action,
      };
      BanApplyAccount(this, params).then((data: any) => {
        this.$message.success(action + "成功");
        this.fetchUsers();
      });
    }
  }
  /**
   * @description 打开查看邀请码弹窗
   */
  private openCheckInviteCodeDialog(user) {
    this.user = user;
    const params: any = {
      params: {
        user_id: user.user_id,
      },
    };
    CheckInviteCode(this, params).then((data: any) => {
      this.inviteCodes = data.codes;
      this.ifShowInviteCode = true;
    });
  }
  /**
   * @description 自动计算邀请码显示的机构名
   */
  private calInviteJigou(juese) {
    let jigouText = "";
    juese["组织机构"].forEach((jigou: any) => {
      jigouText += jigou["名称"] + "-";
    });
    jigouText = jigouText.substring(0, jigouText.length - 1);
    return jigouText;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.filter = this.localFilter;
    this.fetchJigouList();
    this.fetchUsers();
  }
}
